import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TCcCardGeoDeliveryDesktop } from '../models';

export const CcCardGeoDeliveryDesktop: FC<TCcCardGeoDeliveryDesktop> = ({
    Aligner,
    Block,
    GeoInfoConsumer,
    GeoInformerComponent,
    GeoInformerTitle,
    Grid,
    Text,
    children,
    showGeoLink = true,
    styles,
    title,
    useNamedContainers,
}) => {
    // Подготавливаем именованные контейнеры
    const {
        content: namedContent,
        footer: namedFooter,
        footerGeo: namedFooterGeo,
        image: namedImage,
    } = useNamedContainers(children);

    const hasFooter = namedFooterGeo || namedFooter;

    return (
        <Block notPadded shadow={false}>
            <Block className={cn(styles.wrapper)} notPadded theme="grey">
                <Grid collapse columnsWidth={[32, 0.4, 24, null]}>
                    <></>
                    <>
                        {title && (
                            <Text styler={{ marginTop: 32, marginBottom: 8 }} view="small">
                                {title}
                                <br />
                                {showGeoLink && (
                                    <GeoInfoConsumer>
                                        <GeoInformerTitle />
                                    </GeoInfoConsumer>
                                )}
                            </Text>
                        )}
                        <Text styler={{ marginTop: 0, marginBottom: 24 }} view="xsmall">
                            {namedContent}
                        </Text>
                        {hasFooter && <Text styler={{ marginTop: 0, marginBottom: 24 }} />}
                        {namedFooter}
                        {namedFooterGeo && (
                            <GeoInfoConsumer>
                                <GeoInformerComponent>{namedFooterGeo}</GeoInformerComponent>
                            </GeoInfoConsumer>
                        )}
                    </>
                    <></>
                    <Aligner align="right">{namedImage}</Aligner>
                </Grid>
            </Block>
        </Block>
    );
};
